import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {mergeMap, switchMap} from 'rxjs/operators';
import {from} from 'rxjs';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {HttpErrorResponse} from '@angular/common/http';
import {GeneralModalComponent} from "../../../modals/general/general-modal/general-modal.component";
import {Reservation} from "../../../classes/reservation";
import {ReservationService} from "../../../services/reservation";
import {InspectionService} from "../../../services/inspection";
import {Inspection} from "../../../classes/inspection";
import {AuthService} from "../../../services/auth";
import {
    ReservationCreateModalComponent
} from "../../../modals/reservation/reservation-create-modal/reservation-create-modal.component";
import {User} from "../../../classes/user";
import {
    InspectionAssignModalComponent
} from "../../../modals/inspection/inspection-assign-modal/inspection-assign-modal.component";
import {InspectionState} from "../../../classes/inspectionState";
import {InspectionStateService} from "../../../services/inspectionState";
import {
    InspectionViewReservationModalComponent
} from "../../../modals/inspection/inspection-view-reservation-modal/inspection-view-reservation-modal.component";
import {ContractService} from "../../../services/contract";
import {Contract} from "../../../classes/contract";
import {PaService} from "../../../services/pa";
import {UserService} from "../../../services/user";
import {ContractFounderService} from "../../../services/contractFounder";
import {Pa} from "../../../classes/pa";
import {ContractFounder} from "../../../classes/contractFounder";
import {ActivatedRoute, Router} from "@angular/router";
import {ChecklistVoteService} from "../../../services/checklistVote";
import {InspectionOrderService} from "../../../services/inspectionOrder";

@Component({
    selector: 'app-inspection-general',
    templateUrl: './inspection-general.component.html',
    styleUrls: ['./inspection-general.component.css'],
    changeDetection: ChangeDetectionStrategy.Default
})
export class InspectionGeneralComponent implements OnInit {

    // Pagination Parameters
    paginationConfig = {
        itemsPerPage: 10,
        currentPage: 1
    };
    paginationParams = {
        autoHide: true,
        maxSize: 7,
        responsive: true
    };
    paginationLabels = {
        previousLabel: 'Precedente',
        nextLabel: 'Successiva',
        screenReaderPaginationLabel: 'Paginazione',
        screenReaderPageLabel: 'pagina',
        screenReaderCurrentLabel: `Sei sulla pagina`
    };

    // Inspection data
    action: string = '';
    inspections: Array<Inspection> = [];
    inspectionStates: Array<InspectionState> = [];
    contracts: Array<Contract> = [];
    pas: Array<Pa> = [];
    users: Array<User> = [];
    contractFounders: Array<ContractFounder> = [];
    reservationsByInspection: any;
    userReservations: any;

    // User data
    user = new User();

    // Inspections data
    inspectionView = '';
    inspectionSearchParams = {
        operator: 'and',
        status: [1, 2, 3, 4, 5, 6],
        fk_id_inspection_state: null,
        fk_id_pa: null,
        fk_id_contract: null,
        fk_id_user: null,
        fk_id_contract_founder: null
    };

    constructor(private router: Router,
                private route: ActivatedRoute,
                private inspectionService: InspectionService,
                private inspectionOrderService: InspectionOrderService,
                private inspectionStateService: InspectionStateService,
                private reservationService: ReservationService,
                private contractService: ContractService,
                private paService: PaService,
                private userService: UserService,
                private contractFounderService: ContractFounderService,
                private authService: AuthService,
                private checklistVoteService: ChecklistVoteService,
                private modalService: NgbModal) {
    }

    ngOnInit(): void {
        this.action = this.router.url.split('/')[1].split('?')[0];
        this.user = this.authService.getUser();
        this.inspectionView = (this.user.fk_id_role <= 2) ? '' : 'all';

        let inspectionStates: Array<any> = [];
        switch (this.action) {
            case 'inspection-general':
                inspectionStates = [1, 2, 3, 4, 5, 6];
                break;

            case 'schedule':
                this.inspectionSearchParams.status = [1, 2, 3];
                inspectionStates = [1, 2, 3];
                break;

            case 'inspection':
                switch (this.user.fk_id_role) {
                    case 1:
                        this.inspectionSearchParams.status = [4, 5, 6];
                        inspectionStates = [4, 5, 6];
                        break;

                    case 2:
                        this.inspectionSearchParams.status = [4, 5];
                        inspectionStates = [4, 5];
                        break;

                    case 3:
                        inspectionStates = [4, 5, 6];
                        break;

                    case 4:
                        inspectionStates = [6];
                        break;
                }
                break;
        }

        this.route.queryParams
            .subscribe(params => {
                    if (Object.keys(params).length > 0) {
                        this.inspectionSearchParams.operator = params.operator;
                        // @ts-ignore
                        this.inspectionSearchParams.fk_id_inspection_state = (params.status !== undefined) ? parseInt(params.status) : null;
                        // @ts-ignore
                        this.inspectionSearchParams.fk_id_pa = (params.pa !== undefined) ? parseInt(params.pa) : null;
                        // @ts-ignore
                        this.inspectionSearchParams.fk_id_contract = (params.contract !== undefined) ? parseInt(params.contract) : null;
                        // @ts-ignore
                        this.inspectionSearchParams.fk_id_user = (params.inspector !== undefined) ? parseInt(params.inspector) : null;
                        // @ts-ignore
                        this.inspectionSearchParams.fk_id_contract_founder = (params.contract_founder !== undefined) ? parseInt(params.contract_founder) : null;

                        this.searchInspections();
                    } else {
                        this.inspections = [];
                        this.inspectionService.getByIDInspectionState(inspectionStates)
                            .pipe(
                                switchMap((inspectionsData: any) => from(inspectionsData)),
                            )
                            .subscribe({
                                next: (inspection: any) => {
                                    this.inspections.push(inspection);
                                },
                                error: e => {
                                    console.log(e);
                                }
                            });
                    }
                }
            );

        this.inspectionStateService.getAll()
            .pipe(
                switchMap((inspectionStatesData: any) => from(inspectionStatesData))
            )
            .subscribe({
                next: (inspectionState: any) => {
                    if (inspectionStates.includes(inspectionState.id_inspection_state)) {
                        this.inspectionStates.push(inspectionState);
                    }
                },
                error: e => {
                    console.log(e);
                }
            });
        this.contractService.getAll()
            .pipe(
                switchMap((contractsData: any) => from(contractsData))
            )
            .subscribe({
                next: (contract: any) => {
                    this.contracts.push(contract);
                },
                error: e => {
                    console.log(e);
                }
            });
        this.paService.getAll()
            .pipe(
                switchMap((pasData: any) => from(pasData))
            )
            .subscribe({
                next: (pa: any) => {
                    this.pas.push(pa);
                },
                error: e => {
                    console.log(e);
                }
            });
        this.userService.getAll()
            .pipe(
                switchMap((usersData: any) => from(usersData))
            )
            .subscribe({
                next: (user: any) => {
                    this.users.push(user);
                },
                error: e => {
                    console.log(e);
                }
            });
        this.contractFounderService.getAll()
            .pipe(
                switchMap((contractFoundersData: any) => from(contractFoundersData))
            )
            .subscribe({
                next: (contractFounder: any) => {
                    this.contractFounders.push(contractFounder);
                },
                error: e => {
                    console.log(e);
                }
            });
        this.reservationService.getByIdUserGroupByIdInspection((this.user.id_user || '').toString())
            .subscribe({
                next: (reservationsByIDUser: any) => {
                    this.userReservations = reservationsByIDUser;
                },
                error: e => {
                    console.log(e);
                }
            });
        this.reservationService.getGroupByIDInspection()
            .subscribe({
                next: (reservationGroupedByIDInspection: any) => {
                    this.reservationsByInspection = reservationGroupedByIDInspection;
                },
                error: e => {
                    console.log(e);
                }
            });
    }

    onPageChange(pageNumber: number) {
        this.paginationConfig.currentPage = pageNumber;
    }

    onPageBoundsCorrection(pageNumber: number) {
        this.paginationConfig.currentPage = pageNumber;
    }

    goToSearch() {
        this.router.navigate(
            ['/' + this.action],
            {
                queryParams: {
                    status: this.inspectionSearchParams.fk_id_inspection_state,
                    pa: this.inspectionSearchParams.fk_id_pa,
                    contract_founder: this.inspectionSearchParams.fk_id_contract_founder,
                    contract: this.inspectionSearchParams.fk_id_contract,
                    inspector: this.inspectionSearchParams.fk_id_user,
                    operator: this.inspectionSearchParams.operator
                }
            }
        );
    }

    searchInspections() {
        this.inspectionService.search(this.inspectionSearchParams)
            .subscribe({
                next: (inspections: any) => {
                    this.inspections = inspections;
                },
                error: e => {
                    console.log(e);
                }
            });
    }

    resetSearch() {
        this.inspectionSearchParams = {
            operator: 'and',
            status: [1, 2, 3, 4, 5, 6],
            fk_id_inspection_state: null,
            fk_id_pa: null,
            fk_id_contract: null,
            fk_id_user: null,
            fk_id_contract_founder: null
        };

        switch (this.action) {
            case 'schedule':
                this.inspectionSearchParams.status = [1, 2, 3];
                break;

            case 'inspection':
                switch (this.user.fk_id_role) {
                    case 1:
                        this.inspectionSearchParams.status = [4, 5, 6];
                        break;

                    case 2:
                        this.inspectionSearchParams.status = [4];
                        break;
                }
                break;
        }

        this.router.navigate(['/' + this.action]);
    }

    openCreateReservationModal(inspection: Inspection) {
        const modalRef = this.modalService.open(GeneralModalComponent);
        modalRef.componentInstance.title = 'Prenotazione <strong>Ispezione</strong>';
        modalRef.componentInstance.text = 'Confermi la prenotazione dell\'ispezione della PA "' + inspection.pa.name + '"?';
        modalRef.result.then(() => {
            let reservation = new Reservation();
            reservation.fk_id_inspection = inspection.id_inspection;
            reservation.state = 0;
            reservation.fk_id_user = this.user.id_user;
            this.reservationService.create(reservation)
                .subscribe({
                    next: (reservationCreated: any) => {
                        (this.userReservations[inspection.id_inspection!] ??= []).push(reservationCreated);
                    },
                    error: (err: HttpErrorResponse) => {
                        console.log(err);
                    }
                });
        });
    }

    openDeleteReservationModal(inspection: Inspection) {
        const modalRef = this.modalService.open(GeneralModalComponent);
        modalRef.componentInstance.title = 'Annullamento Prenotazione <strong>Ispezione</strong>';
        modalRef.componentInstance.text = 'Confermi l\'annullamento della prenotazione dell\'ispezione della PA "' + inspection.pa.name + '"?';
        modalRef.result.then(() => {
            this.reservationService.delete(this.userReservations[inspection.id_inspection!][0].id_reservation)
                .subscribe({
                    next: () => {
                        delete this.userReservations[inspection.id_inspection!];
                    },
                    error: (err: HttpErrorResponse) => {
                        console.log(err);
                    }
                });
        });
    }

    openViewReservationModal(inspection: Inspection) {
        const modalRef = this.modalService.open(InspectionViewReservationModalComponent, {
            size: 'lg',
            backdrop: 'static'
        });
        modalRef.componentInstance.setIDInspection(inspection.id_inspection);
        modalRef.result.then((userInspector: User) => {
            inspection.fk_id_user = userInspector.id_user;
            inspection.fk_id_inspection_state = 2;
            inspection.inspection_state = this.inspectionStates.find((inspectionState: InspectionState) => inspectionState.id_inspection_state === 2);
            this.inspectionService.update(inspection)
                .subscribe({
                    next: () => {
                        this.inspections = this.inspections.map((currInspection: any) => {
                            if (currInspection.id_inspection === inspection.id_inspection) {
                                return {
                                    ...currInspection,
                                    fk_id_inspection_state: 2,
                                    inspection_state: this.inspectionStates.find((inspectionState: InspectionState) => inspectionState.id_inspection_state === 2),
                                    fk_id_user: userInspector.id_user,
                                    user: userInspector
                                };
                            }
                            return currInspection;
                        });
                    },
                    error: (err: HttpErrorResponse) => {
                        console.log(err);
                    }
                });
        });
    }

    openAssignInspectionModal(inspection: Inspection) {
        const modalRef = this.modalService.open(InspectionAssignModalComponent, {size: 'lg', backdrop: 'static'});
        modalRef.componentInstance.inspection = inspection;

        modalRef.result.then((userInspector: User) => {
            inspection.fk_id_user = userInspector.id_user;
            inspection.fk_id_inspection_state = 2;
            inspection.inspection_state = this.inspectionStates.find((inspectionState: InspectionState) => inspectionState.id_inspection_state === 2);
            this.inspectionService.update(inspection)
                .subscribe({
                    next: () => {
                        this.inspections = this.inspections.map((currInspection: any) => {
                            if (currInspection.id_inspection === inspection.id_inspection) {
                                return {
                                    ...currInspection,
                                    fk_id_inspection_state: 2,
                                    inspection_state: this.inspectionStates.find((inspectionState: InspectionState) => inspectionState.id_inspection_state === 2),
                                    fk_id_user: userInspector.id_user,
                                    user: userInspector
                                };
                            }
                            return currInspection;
                        });
                    },
                    error: (err: HttpErrorResponse) => {
                        console.log(err);
                    }
                });
        });
    }

    openPlanInspectionModal(inspection: Inspection) {
        const modalRef = this.modalService.open(ReservationCreateModalComponent);
        modalRef.result.then((date: Date) => {
            inspection.date = date;
            inspection.fk_id_inspection_state = 3;
            inspection.inspection_state = this.inspectionStates.find((inspectionState: InspectionState) => inspectionState.id_inspection_state === 3);
            this.inspectionService.update(inspection)
                .subscribe({
                    next: () => {
                        this.inspections = this.inspections.map((currInspection: any) => {
                            if (currInspection.id_inspection === inspection.id_inspection) {
                                return {
                                    ...currInspection,
                                    fk_id_inspection_state: 3,
                                    inspection_state: this.inspectionStates.find((inspectionState: InspectionState) => inspectionState.id_inspection_state === 3),
                                    date: inspection.date
                                };
                            }
                            return currInspection;
                        });
                    },
                    error: (err: HttpErrorResponse) => {
                        console.log(err);
                    }
                });
        });
    }

    openRegisterInspectionModal(inspection: Inspection) {
        const modalRef = this.modalService.open(GeneralModalComponent);
        modalRef.componentInstance.title = 'Reset <strong>Ispezione</strong>';
        modalRef.componentInstance.text = 'Confermi la registrazione dell\'ispezione della PA "' + inspection.pa.name + '"?';
        modalRef.result.then(() => {
            if (inspection.id_inspection) {
                inspection.fk_id_inspection_state = 4;
                this.inspectionService.update(inspection)
                    .subscribe({
                        next: () => {
                            this.inspections = this.inspections.filter((currInspection: any) => {
                                return currInspection.id_inspection !== inspection.id_inspection;
                            });
                        },
                        error: (err: HttpErrorResponse) => {
                            console.log(err);
                        }
                    });
            }
        });
    }

    openValidateInspectionModal(inspection: Inspection) {
        const modalRef = this.modalService.open(GeneralModalComponent);
        modalRef.componentInstance.title = 'Reset <strong>Ispezione</strong>';
        modalRef.componentInstance.text = 'Confermi la validazione dell\'ispezione della PA "' + inspection.pa.name + '"?';
        modalRef.result.then(() => {
            if (inspection.id_inspection) {
                inspection.fk_id_inspection_state = 6;
                inspection.date_validation = new Date();
                this.inspectionService.update(inspection)
                    .subscribe({
                        next: () => {
                            this.inspections = this.inspections.map((currInspection: any) => {
                                if (currInspection.id_inspection === inspection.id_inspection) {
                                    return {
                                        ...currInspection,
                                        fk_id_inspection_state: 6,
                                        inspection_state: this.inspectionStates.find((inspectionState: InspectionState) => inspectionState.id_inspection_state === 6),
                                        date: inspection.date
                                    };
                                }
                                return currInspection;
                            });
                        },
                        error: (err: HttpErrorResponse) => {
                            console.log(err);
                        }
                    });
            }
        });
    }

    openDeleteValidationInspectionModal(inspection: Inspection) {
        const modalRef = this.modalService.open(GeneralModalComponent);
        modalRef.componentInstance.title = 'Reset <strong>Ispezione</strong>';
        modalRef.componentInstance.text = 'Confermi l\'annullamento della validazione dell\'ispezione della PA "' + inspection.pa.name + '"?';
        modalRef.result.then(() => {
            if (inspection.id_inspection) {
                inspection.fk_id_inspection_state = 5;
                inspection.date_validation = null;
                this.inspectionService.update(inspection)
                    .subscribe({
                        next: () => {
                            this.inspections = this.inspections.map((currInspection: any) => {
                                if (currInspection.id_inspection === inspection.id_inspection) {
                                    return {
                                        ...currInspection,
                                        fk_id_inspection_state: 5,
                                        inspection_state: this.inspectionStates.find((inspectionState: InspectionState) => inspectionState.id_inspection_state === 5),
                                        date: inspection.date
                                    };
                                }
                                return currInspection;
                            });
                        },
                        error: (err: HttpErrorResponse) => {
                            console.log(err);
                        }
                    });
            }
        });
    }

    openResetInspectionModal(inspection: Inspection) {
        const modalRef = this.modalService.open(GeneralModalComponent);
        modalRef.componentInstance.title = 'Reset <strong>Ispezione</strong>';
        modalRef.componentInstance.text = 'Confermi il reset dell\'ispezione della PA "' + inspection.pa.name + '"?';
        modalRef.result.then(() => {
            if (inspection.id_inspection) {
                inspection.fk_id_inspection_state = 1;
                inspection.fk_id_user = null;
                inspection.date = null;
                inspection.date_inspection = null;
                inspection.date_validation = null;
                inspection.referent_name = null;
                inspection.referent_surname = null;
                inspection.referent_function = null;
                inspection.inspector_name = null;
                inspection.inspector_surname = null;
                inspection.start_hour = null;
                inspection.end_hour = null;
                this.inspectionService.update(inspection)
                    .pipe(
                        mergeMap(() => this.checklistVoteService.deleteByIDInspection(inspection.id_inspection!)),
                        mergeMap(() => this.inspectionOrderService.resetByIDInspection(inspection.id_inspection!)),
                    )
                    .subscribe({
                        next: () => {
                            this.inspections = this.inspections.map((currInspection: any) => {
                                if (currInspection.id_inspection === inspection.id_inspection) {
                                    return {
                                        ...currInspection,
                                        fk_id_inspection_state: 1,
                                        inspection_state: this.inspectionStates.find((inspectionState: InspectionState) => inspectionState.id_inspection_state === 1),
                                        fk_id_user: null,
                                        user: null,
                                        date: null
                                    };
                                }
                                return currInspection;
                            });

                            if (this.action === 'inspection') {
                                this.inspections = this.inspections.filter((currInspection: any) => {
                                    return currInspection.id_inspection !== inspection.id_inspection;
                                });
                            }
                        },
                        error: (err: HttpErrorResponse) => {
                            console.log(err);
                        }
                    });
            }
        });
    }

    openDeleteInspectionModal(inspection: Inspection) {
        const modalRef = this.modalService.open(GeneralModalComponent);
        modalRef.componentInstance.title = 'Rimozione <strong>Ispezione</strong>';
        modalRef.componentInstance.text = 'Confermi la rimozione dell\'ispezione della PA "' + inspection.pa.name + '"?';
        modalRef.result.then(() => {
            if (inspection.id_inspection) {
                this.inspectionService.delete(inspection.id_inspection)
                    .subscribe({
                        next: () => {
                            this.inspections = this.inspections.filter((currInspection: Inspection) => currInspection.id_inspection !== inspection.id_inspection);
                            this.paginationConfig.currentPage = 1;
                        },
                        error: (err: HttpErrorResponse) => {
                            console.log(err);
                        }
                    });
            }
        });
    }

}
